module.exports = __webpack_public_path__ + "img/bull-placeholder.e74b4a6b.gif";